import { Typography } from '@/components/typography/typography'
import { useDevice } from '@/hooks/useDevice'
import { cn } from '@/libs/tw'
import { useCartStore } from '@/stores/cart-store/cartStore'
import { formatCurrency } from '@/utils/formatCurrency'
import { translate } from '@/utils/translator'

export const TotalBookingPrice = () => {
	const { isTablet } = useDevice()
	const { selectedRooms } = useCartStore.use.roomSelection()

	const totalPrice = selectedRooms.reduce((prev, { room }) => {
		const totalServiceCost = room.services.reduce(
			(prev, curr) => prev + (curr.price?.amountAfterTax ?? 0),
			0
		)
		return (
			prev +
			(room.rate?.price.amountAfterTax ? room.rate.price.amountAfterTax : 0) +
			totalServiceCost
		)
	}, 0)

	return (
		<div
			data-testid="bp-total-price"
			className={cn('flex gap-12 px-16 md:flex-col md:gap-2 lg:px-32')}
		>
			{isTablet ? (
				<>
					<Typography style="p-s" element="p">
						{translate('progress-total-price')}
					</Typography>
					<Typography style="p-s-bold" element="p">
						{formatCurrency(totalPrice, true)}
					</Typography>
				</>
			) : (
				<>
					<Typography style="p" element="p">
						{translate('progress-total-price')}
					</Typography>
					<Typography style="p-bold" element="p">
						{formatCurrency(totalPrice, true)}
					</Typography>
				</>
			)}
		</div>
	)
}
